import { GetLandingPageContent } from '@/application/landing/GetLandingPageContent';
import { StaticLandingContentRepository } from '@/infrastructure/landing/StaticLandingContentRepository';

export const createLandingPageDependencies = () => {
  const repository = new StaticLandingContentRepository();
  const getLandingPageContent = new GetLandingPageContent(repository);

  return {
    getLandingPageContent,
  };
};

